module.exports = __webpack_public_path__ + "img/5.b0590020.svg";